import React from "react";
import { Ticket, ChevronRight, Star } from "lucide-react";

export default function BookTicketsButton() {
  const handleBookTickets = () => {
    window.open("https://grandcinemaz.com/shows", "_blank");
  };

  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-[#3c0d0d] via-[#1b1c3b] to-[#000814] p-8">
      {/* flex-column so everything (h2, button, p) stays centered */}
      <div className="flex flex-col items-center text-center">
        <h2 className="text-3xl font-bold text-white mb-8">
          Ready to Experience Premium Cinema?
        </h2>

        <button
          onClick={handleBookTickets}
          /* mx-auto centers the button; rest of the classes stay the same */
          className="mx-auto group relative flex items-center gap-3 py-4 px-8 bg-gradient-to-r from-[#b3001b] to-[#ff4d4d] rounded-full text-white transition-all duration-300 hover:shadow-2xl hover:shadow-[#b3001b]/50 hover:scale-105 active:scale-95 overflow-hidden"
        >
          {/* Animated background shimmer */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

          {/* Button content */}
          <div className="relative flex items-center gap-3">
            <div className="flex items-center gap-2">
              <Star className="h-5 w-5 fill-white transition-transform duration-300 group-hover:rotate-12" />
              <Ticket className="h-5 w-5 fill-white transition-transform duration-300 group-hover:scale-110" />
            </div>

            <span className="text-lg font-semibold tracking-wide">
              BOOK TICKETS NOW
            </span>

            <ChevronRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-2" />
          </div>

          {/* Pulsing border effect */}
          <div className="absolute inset-0 rounded-full border-2 border-white/20 group-hover:border-white/40 transition-all duration-300" />
        </button>

        <p className="text-gray-300 text-sm mt-4 font-light">
          Click to view showtimes and book your premium experience
        </p>
      </div>
    </div>
  );
}
